import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const CategoryAccordion = ({ title, count, children, styles, forceOpen = false, action }) => {
  const [isOpen, setIsOpen] = useState(forceOpen);

  useEffect(() => {
    if (forceOpen) setIsOpen(true);
  }, [forceOpen]);

  return (
    <div style={styles.accordion.wrapper}>
      <div style={styles.accordion.header(isOpen)}>
        <div 
          onClick={() => setIsOpen(!isOpen)}
          style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", flex: 1 }}
        >
          {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
          <span style={styles.accordion.title(isOpen)}>
            {title}
          </span>
          <span style={{ fontSize: "12px", color: styles.colors.muted, fontWeight: "normal" }}>
            ({count})
          </span>
        </div>
        
        {action && (
          <div style={{ marginLeft: "10px", display: "flex", alignItems: "center", gap: "5px" }}>
            {action}
          </div>
        )}
      </div>

      {isOpen && (
        <div style={{ borderTop: `1px solid ${styles.colors.cardBorder}`, padding: "0" }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CategoryAccordion;